import React from 'react';
import styled from 'styled-components';

const QtyBtn = styled.button.attrs({
  className: 'bundle-quantity-button',
})`
  font-size: 16px;
  font-weight: 400;
  border: none;
  background: none;
  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
    filter: grayscale(100%);
  }
`;

const QtyValue = styled.span.attrs({
  className: 'bundle-quantity-value',
})`
  font-size: 16px;
  font-weight: 400;
  margin-left: 6px;
  margin-right: 6px;
`;

interface QuantityButtonProps {
  value?: number;
  onDecrease?: (value) => void;
  onIncrease?: (value) => void;
  hideButtons?: boolean;
  isIncreaseDisabled?: boolean;
  isDecreaseDisabled?: boolean;
}

const QuantityButton = ({
  onDecrease,
  onIncrease,
  hideButtons,
  value,
  isIncreaseDisabled = false,
  isDecreaseDisabled = false,
}: QuantityButtonProps): React.ReactElement => (
  <>
    {!hideButtons && (
      <QtyBtn
        data-testid="decrease-button"
        disabled={isDecreaseDisabled}
        onClick={() => {
          if (onDecrease && !isDecreaseDisabled) onDecrease(value);
        }}
      >
        -
      </QtyBtn>
    )}
    <QtyValue>{value}</QtyValue>
    {!hideButtons && (
      <QtyBtn
        data-testid="increase-button"
        disabled={isIncreaseDisabled}
        onClick={() => {
          if (onIncrease && !isIncreaseDisabled) onIncrease(value);
        }}
      >
        +
      </QtyBtn>
    )}
  </>
);

export default QuantityButton;
